export function formatNumberDefault(value: number): string {
  return value?.toLocaleString('pt-BR');
}
